exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal .error-header button.close {\n  color: transparent;\n}\n.modal .error-header .modal-title {\n  display: none;\n}\n", ""]);

// exports
